import React from "react";
import { useQuery } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { PageHeader } from "@/components/common/Page";
import { Users, ArrowRight, AlertTriangle } from "lucide-react";

export default function LegalCustomers() {
  const navigate = useNavigate();
  const { data: customers } = useQuery({ queryKey: ["customers"], queryFn: async () => (await api.get("/customers")).data });
  const { data: contracts } = useQuery({ queryKey: ["legal-contracts"], queryFn: async () => (await api.get("/legal/contracts")).data });

  const byCustomer = {};
  (contracts || []).forEach((c) => {
    const b = (byCustomer[c.customer_id] = byCustomer[c.customer_id] || { total: 0, active: 0 });
    b.total += 1;
    if (["Active", "Executed"].includes(c.lifecycle_status)) b.active += 1;
  });

  return (
    <div data-testid="legal-customers-page">
      <PageHeader title="Customers — Contracts & Legal" subtitle="Each customer references your existing NavScora customer record." />
      <div className="grid gap-3 md:grid-cols-2 lg:grid-cols-3">
        {(customers || []).map((c) => {
          const b = byCustomer[c.id] || { total: 0, active: 0 };
          return (
            <button key={c.id} onClick={() => navigate(`/customers/${c.id}`)} className="rounded-xl border border-[#1E2D4A] bg-[#111A2E]/70 p-4 text-left hover:border-cyan-500/40" data-testid={`legal-customer-${c.id}`}>
              <div className="flex items-center justify-between">
                <span className="flex items-center gap-2 font-medium text-slate-100"><Users className="h-4 w-4 text-cyan-400" />{c.legal_name}</span>
                <ArrowRight className="h-4 w-4 text-slate-500" />
              </div>
              <div className="mt-2 flex gap-2 text-xs">
                <span className="rounded bg-[#0B1120] px-2 py-1 text-slate-400">{b.total} contract(s)</span>
                {b.active > 0
                  ? <span className="rounded bg-emerald-500/15 px-2 py-1 text-emerald-300">{b.active} active</span>
                  : <span className="flex items-center gap-1 rounded bg-amber-500/15 px-2 py-1 text-amber-300"><AlertTriangle className="h-3 w-3" /> no active agreement</span>}
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
}
